import { DOCUMENT } from '@angular/common';
import { DestroyRef, Injectable, inject, signal } from '@angular/core';

const DEFAULT_LOGO = 'reverb/ReverbLogoAndText.svg';
const HALLOWEEN_LOGO = 'reverb/ReverbLogoAndTextHalloween.svg';

/** Navigation-only branding, based on the browser's current local calendar. */
@Injectable()
export class SeasonalLogo {
  readonly src = signal(DEFAULT_LOGO);

  constructor() {
    const document = inject(DOCUMENT);
    const window = document.defaultView;
    if (!window) return;

    let timer: ReturnType<typeof setTimeout>;
    const refresh = () => {
      clearTimeout(timer);
      const now = new Date();
      // October 17 at 00:00 inclusive through November 1 at 00:00 exclusive,
      // every year. Local constructors also account for daylight saving time.
      const start = new Date(now.getFullYear(), 9, 17);
      const end = new Date(now.getFullYear(), 10, 1);
      this.src.set(now >= start && now < end ? HALLOWEEN_LOGO : DEFAULT_LOGO);

      const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      // Recheck clock/timezone changes each minute; land exactly on midnight.
      timer = setTimeout(refresh, Math.min(60_000, midnight.getTime() - now.getTime()));
    };

    refresh();
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    inject(DestroyRef).onDestroy(() => {
      clearTimeout(timer);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    });
  }
}
